module.exports = __webpack_public_path__ + "assets/images/icons/work.svg?v=11b3417c";